module.exports = __webpack_public_path__ + "img/1565980591.feb4eb81.jpg";